var React = require('react');

function UserInfo2 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"b"},React.createElement("rect",{"width":"24","height":"24"}))),React.createElement("g",{"id":"a","clipPath":"url(#b)","key":1},React.createElement("g",{"transform":"translate(-135 51)"},React.createElement("path",{"d":"M19,4H5A3,3,0,0,0,2,7V17a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V7a3,3,0,0,0-3-3Zm-.67,2L12,10.75,5.67,6ZM19,18H5a1,1,0,0,1-1-1V7.25l7.4,5.55a1,1,0,0,0,1.2,0L20,7.25V17A1,1,0,0,1,19,18Z","transform":"translate(135 -51)","fill":"#00008f"})))]);
}

UserInfo2.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = UserInfo2;

UserInfo2.default = UserInfo2;
